<template>
  <!-- BEGIN: Content-->
  <div class="app-content content ">
    <div class="content-overlay"></div>
    <div class="header-navbar-shadow"></div>
    <div class="content-wrapper">
      <div class="content-header row">
        <div class="content-header-left col-md-9 col-12 mb-2">
          <Breadcrumb
            name="Update Details"
            bc1="App"
            bc2="Features"
            bc3="Update"
            path="Features"
          ></Breadcrumb>
        </div>

      </div>
      <div class="content-body">
        <!-- Basic Horizontal form layout section start -->
        <section id="basic-horizontal-layouts">
          <div class="row">
            <div class="col-md-12 col-12">
              <div class="card">
                <div class="card-header">
                  <h4 class="card-title">Update Details</h4>
                </div>
                <div class="card-body">
                  <form class="form form-horizontal">
                    <div class="row">
                      <!--                      <div class="col-12">-->
                      <!--                        <div class="form-group row">-->
                      <!--                          <div class="col-sm-3 col-form-label">-->
                      <!--                            <label for="name-icon">Name</label>-->
                      <!--                          </div>-->
                      <!--                          <div class="col-sm-9">-->
                      <!--                            <div class="input-group">-->
                      <!--                              <div class="input-group-prepend">-->
                      <!--                                <span class="input-group-text"-->
                      <!--                                  ><i class="far fa-user"></i-->
                      <!--                                ></span>-->
                      <!--                              </div>-->
                      <!--                              <input-->
                      <!--                                type="text"-->
                      <!--                                v-model="name"-->
                      <!--                                id="name-icon"-->
                      <!--                                class="form-control"-->
                      <!--                                :class="-->
                      <!--                                  errorBag.has('name') ? 'is-invalid' : ''-->
                      <!--                                "-->
                      <!--                                name="name"-->
                      <!--                                placeholder="Name"-->
                      <!--                                v-validate="'required'"-->
                      <!--                              />-->
                      <!--                              <small-->
                      <!--                                v-show="errorBag.has('name')"-->
                      <!--                                class="invalid-feedback"-->
                      <!--                                >{{ "*" + errorBag.first("name") }}</small-->
                      <!--                              >-->
                      <!--                            </div>-->
                      <!--                          </div>-->
                      <!--                        </div>-->
                      <!--                      </div>-->
                      <!--                      <div class="col-12">-->
                      <!--                        <div class="form-group row">-->
                      <!--                          <div class="col-sm-3 col-form-label">-->
                      <!--                            <label>Type</label>-->
                      <!--                          </div>-->
                      <!--                          <div class="col-sm-9">-->
                      <!--                            <div class="input-group">-->
                      <!--                              <b-form-select-->
                      <!--                                v-model="type"-->
                      <!--                                size="sm"-->
                      <!--                                name="type"-->
                      <!--                                v-validate="'required'"-->
                      <!--                                class="mt-1"-->
                      <!--                                :class="-->
                      <!--                                  errorBag.has('type') ? 'is-invalid' : ''-->
                      <!--                                "-->
                      <!--                              >-->
                      <!--                                <b-form-select-option value=""-->
                      <!--                                  >Please Select Type-->
                      <!--                                </b-form-select-option>-->
                      <!--                                <b-form-select-option-->
                      <!--                                  v-for="(item, index) in options"-->
                      <!--                                  :value="item.id"-->
                      <!--                                  :key="index"-->
                      <!--                                  >{{ item.text }}-->
                      <!--                                </b-form-select-option>-->
                      <!--                              </b-form-select>-->
                      <!--                              <small-->
                      <!--                                v-show="errorBag.has('type')"-->
                      <!--                                class="invalid-feedback"-->
                      <!--                                >{{ "*" + errorBag.first("type") }}</small-->
                      <!--                              >-->
                      <!--                            </div>-->
                      <!--                          </div>-->
                      <!--                        </div>-->
                      <!--                      </div>-->
                      <div class="col-12">
                        <div class="form-group row">
                          <div class="col-sm-3 col-form-label">
                            <label>Status</label>
                          </div>
                          <div class="col-sm-9">
                            <div class="input-group">
                              <select class="form-control" v-model="recordStatus">
                                <option
                                  v-for="(item, index) in recordStatusOptions"
                                  :key="index"
                                  :value="item.id"
                                >{{ item.value }}
                                </option
                                >
                              </select>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-12">
                        <div class="form-group row">
                          <div class="col-sm-3 col-form-label">
                            <label>Icon</label>
                          </div>
                          <div class="col-sm-9">
                            <div class="input-group">
                              <div class="row" v-if="!changeIcon && iconImage">
                                <div class="col-md-6">
                                  <img
                                    width="50"
                                    height="50"
                                    :src="iconImage"
                                  />
                                </div>
                                <div class="col-md-6">
                                  <button
                                    class="btn btn-gradient-secondary btn-sm mt-1"
                                    @click="changeIcon = true"
                                  >
                                    Change
                                  </button>
                                </div>
                              </div>
                              <div class="custom-file" v-if="!iconImage || changeIcon">
                                <input
                                  type="file"
                                  class="custom-file-input"
                                  :class="
                                    errorBag.has('file') ? 'is-invalid' : ''
                                  "
                                  id="customFile1"
                                  name="file"
                                  @change="onFileChanged"

                                />
                                <label
                                  class="custom-file-label"
                                  for="customFile1"
                                > {{ icon ? icon.name : "Choose icon image" }}</label
                                >
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-12">
                        <div class="form-group row">
                          <div class="col-sm-3 col-form-label">
                            <label>Web Icon</label>
                          </div>
                          <div class="col-sm-9">
                            <div class="input-group">
                              <div class="row" v-if="!changeWebIcon && webIconImage">
                                <div class="col-md-6">
                                  <img
                                    width="50"
                                    height="50"
                                    :src="webIconImage"
                                  />
                                </div>
                                <div class="col-md-6">
                                  <button
                                    class="btn btn-gradient-secondary btn-sm mt-1"
                                    @click="changeWebIcon = true"
                                  >
                                    Change
                                  </button>
                                </div>
                              </div>
                              <div class="custom-file" v-if="!webIconImage || changeWebIcon">
                                <input
                                  type="file"
                                  class="custom-file-input"
                                  :class="
                                    errorBag.has('file') ? 'is-invalid' : ''
                                  "
                                  id="customFile2"
                                  name="file"
                                  @change="onWebIconChanged"

                                />
                                <label
                                  class="custom-file-label"
                                  for="customFile2"
                                > {{ webIcon ? webIcon.name : "Choose web icon image" }}</label
                                >
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <!--                      <div class="col-12">-->
                      <!--                        <div class="form-group row">-->
                      <!--                          <div class="col-sm-3 col-form-label">-->
                      <!--                            <label for="name-icon">Is Default</label>-->
                      <!--                          </div>-->
                      <!--                          <div class="col-sm-9">-->
                      <!--                            <input-->
                      <!--                              class="custom-checkbox"-->
                      <!--                              type="checkbox"-->
                      <!--                              v-model="isDefault"-->
                      <!--                              :true-value="1"-->
                      <!--                              :false-value="0"-->
                      <!--                              name="isRequiredCheckbox"-->
                      <!--                            />-->
                      <!--                          </div>-->
                      <!--                        </div>-->
                      <!--                      </div>-->
                    </div>
                    <div class="col-sm-9 offset-sm-3 text-right mt-2 d-flex">
                      <button
                        type="button"
                        class="btn btn-primary mr-1 d-flex"
                        @click="sendCall"
                        :disabled="loading"
                      >
                        <Loader :loading="loading" :size="size"></Loader>
                        Save
                      </button>
                      <button
                        type="button"
                        class="btn btn-gradient-secondary"
                        @click="Back()"
                      >
                        Back
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </section>
        <!-- Basic Horizontal form layout section end -->
      </div>
    </div>
  </div>
  <!-- END: Content-->
</template>

<script>


export default {
  mounted() {
    let featuresUpdateData = this.$store.getters.getByKey("featuresUpdate");
    if (featuresUpdateData) {
      this.index = featuresUpdateData.index;
      this.id = featuresUpdateData.id;
      this.name = featuresUpdateData.name;
      this.type = featuresUpdateData.type;
      this.iconImage = featuresUpdateData.icon;
      this.webIconImage = featuresUpdateData.web_icon;
      this.recordStatus = featuresUpdateData.status;
      this.isDefault = featuresUpdateData.parent_id;
    }
  },
  data() {
    return {
      id: "",
      index: "",
      name: "",
      type: "",
      isDefault: "",
      icon: null,
      webIcon: null,
      changeIcon: false,
      changeWebIcon: false,
      iconImage: null,
      webIconImage: null,
      options: [
        {id: 1, text: "Admin"},
        {id: 2, text: "User"},
        {id: 3, text: "Merchant"}
      ],
      recordStatus: 1,
      recordStatusOptions: [
        { id: 0, value: "Inactive" },
        { id: 1, value: "Active For All" },
        { id: 2, value: "Active For Mobile Only" },
        { id: 3, value: "Active For Web Only" }
      ],
      loading: false,
      size: "10px"
    };
  },
  methods: {
    onFileChanged(event) {
      if(event.target.files.length){
        this.icon = event.target.files[0];
      }else{
        this.icon = null
      }

    },
    onWebIconChanged(event) {
      if(event.target.files.length){
        this.webIcon = event.target.files[0];
      }else{
        this.webIcon = null
      }
    },
    Back() {
      this.$emit('back')
    },
    sendCall() {
      this.$validator.validateAll().then(valid => {
        if (valid) {
          this.loading = true;

          var data = {
            id: this.id,
            status: this.recordStatus
          }


          if ((this.changeIcon || !this.iconImage || this.changeWebIcon || !this.webIconImage) && (this.icon || this.webIcon)) {

            let attachment = new FormData();

            attachment.append("parentId", this.isDefault == true ? 1 : false)

            if ((this.changeIcon || !this.iconImage) && this.icon){
              attachment.append("icon", this.icon, this.icon.name);
            }

            if ((this.changeWebIcon || !this.webIconImage) && this.webIcon){
              attachment.append("webIcon", this.webIcon, this.webIcon.name);
            }

            data.hasAttachment = attachment



          }


          this.makeRequest("post", "v1/update-feature", data).then(
            callResponse => {
              if (!callResponse.error) {
                let code = callResponse.response.data.code;
                if (code == 200) {
                  this.loading = false;
                  if (callResponse.response.data.data) {
                    let responseData = callResponse.response.data.data;
                    let storeData = this.$store.getters.getByKey("featuresUpdate");
                    let rawdata = this.$store.getters.getTableData(storeData.storageKey+'_custom')
                    let rowProp = {
                      ...storeData,
                      ...responseData
                    }
                    rawdata[storeData.idx] = rowProp
                    this.$store.dispatch('setTableData', { key: storeData.storageKey+'_custom', data: {...rawdata} })

                    this.$emit('back')
                    return
                  }
                } else {
                  this.loading = false;
                }
              }
            }
          );
        }
      });
    }
  }
};
</script>

